/**
 * @fileoverview Скорость руления с учетом уступки и снега на РД.
 */

import type { GameState, Plane } from "../state/types";
import { clamp } from "../util/math";

/**
 * Скорость наземного руления.
 * Снег на рулежке замедляет, но не останавливает (раньше yieldT=0.15
 * обнулял движение каждый кадр при snow>55 — борта «примерзали»).
 */
export function groundTaxiSpeed(g: GameState, p: Plane): number {
  if (p.yieldT > 0) return 0;
  let sp = p.T.taxi;
  if (
    p.status !== "taxi_gate" &&
    p.status !== "taxi_rwy" &&
    p.status !== "vacating" &&
    !(p.status === "awaiting_gate" && p.path?.length)
  ) {
    return sp;
  }
  const taxi = g.zones.find((z) => z.id === "taxi");
  if (taxi && taxi.snow > 55) {
    // 55% → ~0.85×, 100% → ~0.4×
    sp *= clamp(1 - (taxi.snow - 55) / 100, 0.4, 0.85);
  }
  return sp;
}
